import { useMemo } from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from 'recharts';
import dayjs from 'dayjs';

const colors = {
  final: '#22C55E',
  homework: '#4357AD',
  behavior: '#F59E0B',
  activity: '#EF4444',
  comprehension: '#0891B2',
};

const LessonPerformanceChart = ({ lessons }) => {
  const chartData = useMemo(() => {
    return (lessons || [])
      .slice()
      .sort((a, b) => dayjs(a.date).valueOf() - dayjs(b.date).valueOf())
      .map((lesson) => {
        const scores = [
          lesson.homeworkScore,
          lesson.activityScore,
          lesson.behaviorScore,
          lesson.comprehensionScore,
        ].filter((val) => typeof val === 'number');
        const avg = scores.length ? scores.reduce((sum, val) => sum + val, 0) / scores.length : null;
        return {
          dateLabel: dayjs(lesson.date).format('DD.MM'),
          homework: lesson.homeworkScore,
          activity: lesson.activityScore,
          behavior: lesson.behaviorScore,
          comprehension: lesson.comprehensionScore,
          final: lesson.finalScore ?? (avg ? Number(avg.toFixed(1)) : null),
        };
      });
  }, [lessons]);

  if (!chartData.length) {
    return null;
  }

  return (
    <Card sx={{ borderRadius: 4, boxShadow: '0 1px 6px rgba(0,0,0,0.04)', bgcolor: '#fff' }}>
      <CardContent sx={{ py: 3 }}>
        <Typography variant="h6" fontWeight={700} sx={{ color: '#1E2A4A', mb: 2 }}>
          Динаміка успішності
        </Typography>
        <ResponsiveContainer width="100%" height={320}>
          <BarChart data={chartData} barGap={1} barCategoryGap="20%">
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" vertical={false} />
            <XAxis dataKey="dateLabel" tick={{ fontSize: 12, fill: '#8891A5' }} axisLine={false} tickLine={false} />
            <YAxis domain={[0, 10]} allowDecimals={false} tick={{ fontSize: 12, fill: '#8891A5' }} axisLine={false} tickLine={false} width={28} />
            <Tooltip contentStyle={{ borderRadius: 12, border: 'none', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }} />
            <Legend wrapperStyle={{ fontSize: 12, paddingTop: 8 }} />
            <Bar dataKey="final" name="Підсумок" fill={colors.final} radius={[4, 4, 0, 0]} />
            <Bar dataKey="homework" name="Домашнє завдання" fill={colors.homework} radius={[4, 4, 0, 0]} />
            <Bar dataKey="behavior" name="Поведінка" fill={colors.behavior} radius={[4, 4, 0, 0]} />
            <Bar dataKey="activity" name="Активність" fill={colors.activity} radius={[4, 4, 0, 0]} />
            <Bar dataKey="comprehension" name="Засвоєння матеріалу" fill={colors.comprehension} radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default LessonPerformanceChart;
